import { GetServerSideProps } from 'next'
import { FragmentPage, FragmentPageProps } from '~/components/FragmentPage'
import { Token } from '~/domain/Token'
import { Erc721Token } from '~/services/erc721'
import { getVaultByAddress } from '~/services/vaults'
import { getSeriesById } from '~/services/series'
import { getCollectionWithinSeries } from '~/services/collections'

export const getServerSideProps: GetServerSideProps<FragmentPageProps> = async (context) => {
  const seriesId = context.query.seriesId as string
  const collectionAddress = context.query.collectionAddress as string
  const tokenId = context.query.tokenId as string
  const vaultAddress = context.query.vaultAddress as string
  const fragmentId = context.query.fragmentId as string
  const url = `https://${context.req?.headers.host}${context.resolvedUrl}`

  const series = getSeriesById(seriesId)
  const collection = getCollectionWithinSeries(seriesId, collectionAddress)
  const vault = await getVaultByAddress(seriesId, collectionAddress, tokenId, vaultAddress)

  if (!series || !collection || !vault) {
    return { notFound: true }
  }

  let props: FragmentPageProps = {
    series,
    collection,
    tokenId,
    vault,
    fragmentId,
    url,
  }

  const token: Token = {
    chainId: collection.contract.chainId,
    contractAdress: collection.contract.address,
    tokenId,
  }

  let trophyId: string

  try {
    const erc721Token = new Erc721Token(token)

    trophyId = await erc721Token.getTrophyIdFromMetadata()
    props = { ...props, trophyId }
  } catch (exception: unknown) {
    console.warn(exception)
  }

  return { props }
}

export default FragmentPage
